import { useState, useEffect } from 'react';
import { coverArt } from '../images/cover-art';
import { galleryImages } from '../images';

const useImagePreloader = (type = 'cover') => {
  const [imagesPreloaded, setImagesPreloaded] = useState(false);

  useEffect(() => {
    const imageUrls = type === 'cover' 
      ? Object.values(coverArt)
      : Object.values(galleryImages);

    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(url);
        img.onerror = () => reject(url);
      });
    };

    Promise.all(imageUrls.map(loadImage))
      .then(() => setImagesPreloaded(true))
      .catch((err) => {
        console.error('Error preloading images:', err);
        setImagesPreloaded(true); // Still set to true to not block rendering
      });
  }, [type]);

  return imagesPreloaded;
};

export default useImagePreloader;
